import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MypopComponent} from "./popovers/mypop/mypop.component";
import { AdjustBudgetComponent} from "./popovers/adjust-budget/adjust-budget.component";
import {AuthGuardService  } from './services/auth-guard.service';

import { LazyLoadImageModule } from 'ng-lazyload-image'; // <-- import it
// 
import { IonicStorageModule } from '@ionic/storage-angular';
import { HttpClientModule } from '@angular/common/http';
import { Network } from '@ionic-native/network/ngx';
import {CurrencyPipe} from '@angular/common';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { File, IWriteOptions } from '@ionic-native/file/ngx';
	
import {NgxPaginationModule} from 'ngx-pagination';
import { NgImageSliderModule } from 'ng-image-video-gallery';
import { SafePipe } from './pipes/safe.pipe';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';



@NgModule({
  declarations: [AppComponent,MypopComponent,AdjustBudgetComponent, SafePipe],
  entryComponents: [MypopComponent,AdjustBudgetComponent],
  imports: [
    BrowserModule,
    NgxPaginationModule,
    NgImageSliderModule,
     LazyLoadImageModule ,
    IonicModule.forRoot(),
    AppRoutingModule,
   // CurrencyMaskModule,
    IonicStorageModule.forRoot(),
    HttpClientModule,
    ShareButtonsModule.withConfig({
      debug: true,
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    StatusBar,
    SplashScreen,

    FileOpener,
    
    // FileTransfer,
    File,
    AuthGuardService,
    CurrencyPipe,
   //{ provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    Network
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
